import React, { useEffect, useState, useRef } from 'react'
import Swal from 'sweetalert2';
import { addDoc, collection, doc, getDoc, getDocs, onSnapshot, orderBy, query, Timestamp, updateDoc, where } from 'firebase/firestore';
import { auth, db } from '../../firebase';
import "../../App.css";
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import Menu from '../../panel/Menu';
import { Card, CardContent, FormControl, Grid, InputLabel, MenuItem, Select, TextField, Typography, Button, TableContainer, Table, TableHead, TableRow, Paper, TableCell, TableBody } from '@mui/material';

function Receptionistreport() {
    const Toast = Swal.mixin({
        toast: true,
        position: 'top-end',
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer)
            toast.addEventListener('mouseleave', Swal.resumeTimer)
        }
    });


    const printRef = useRef();
    const [loading, setloading] = useState(false);
    const [loadincount, setloadincount] = useState(true);
    const [userData, setUserData] = useState();
    const [fromDate, setfromDate] = useState("");
    const [toDate, settoDate] = useState("");
    const [receptId, setreceptId] = useState("");
    const [username, setusername] = useState("");
    const [bookingData, setbookingData] = useState([]);
    const [payhistory, setpayhistory] = useState([]);
    const [serviceData, setserviceData] = useState([]);
    const [paymodes, setpaymodes] = useState([]);
    const [recepts, setrecepts] = useState([]);
    const [total, settotal] = useState(0);
    const [propertyId, setPropertyId] = useState("");

    useEffect(() => {
        const unsub = auth.onAuthStateChanged(async (user) => {
            if (!user) return;

            setUserData(user);

            const roleSnap = await getDoc(doc(db, "authroles", user.uid));
            if (roleSnap.exists()) {
                setPropertyId(roleSnap.data().propertyId);
            }
        });

        return () => unsub();
    }, []);

    useEffect(() => {
        if (!propertyId) return;

        const q = query(
            collection(db, "authroles"),
            where("propertyId", "==", propertyId),
            where("role", "==", "Reception")
        );

        const unsub = onSnapshot(q, (querySnapshot) => {
            setrecepts(
                querySnapshot.docs.map((doc) => ({
                    id: doc.id,
                    data: doc.data()
                }))
            );
        });

        return () => unsub();
    }, [propertyId]);


    const getReport = async () => {
        if (!fromDate || !toDate || !receptId) {
            Toast.fire({ icon: "error", title: 'Please select From Date & To Date' });
            return;
        }

        if (!propertyId) {
            Toast.fire({ icon: "error", title: "Property not assigned" });
            return;
        }

        setloading(true);
        setbookingData([]);
        setpaymodes([]);
        setpayhistory([]);

        const startOfDay = new Date(fromDate);
        startOfDay.setHours(0, 0, 0, 0);
        const endOfDay = new Date(toDate);
        endOfDay.setDate(endOfDay.getDate() + 1); // Next day for exclusive range

        const reportDate = moment(fromDate).format('YYYY-MM-DD');
        console.log(receptId);

        // =====================================================================================================================================
        // 1. Fetch both bookings and payhistory in parallel
        const [payHistorySnapshot, serviucesSnapshot] = await Promise.all([
            getDocs(
                query(
                    collection(db, "payhistory"),
                    where("propertyId", "==", propertyId),
                    where("uid", "==", receptId),
                    where("paymenttype", "==", "B"),
                    where("status", "==", "Working"),
                    where("createdAt", ">=", startOfDay),
                    where("createdAt", "<", endOfDay)
                )

            ),
            getDocs(
                query(
                    collection(db, "bookingservices"),
                    where("propertyId", "==", propertyId),
                    where("uid", "==", receptId),
                    where("type", "==", "Booking"),
                    where("createdAt", ">=", startOfDay),
                    where("createdAt", "<", endOfDay)
                )

            )
        ]);


        // 3. Process payhistory data with paymode lookups
        const payHistoryDataPromises = payHistorySnapshot.docs.map(async (doc1) => {
            const docData = doc1.data();
            const [paymode1Snap, paymode2Snap, bookingSnap] = await Promise.all([
                getDoc(doc(db, "paymentmodes", docData.paymode1)),
                getDoc(doc(db, "paymentmodes", docData.paymode2)),
                getDoc(doc(db, "reservations", docData.bookingid))
            ]);

            const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
            const date = docData.createdAt.toDate();
            const formattedDate = `${date.getDate().toString().padStart(2, '0')}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getFullYear()} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;

            let bookingData = {};
            if (bookingSnap.exists()) {
                const bookingDocData = bookingSnap.data();
                bookingData = {
                    rooms: bookingDocData.rooms || [], // Fetch rooms array
                    checkinDate: bookingDocData.checkindate ? bookingDocData.checkindate : null, // Convert checkindate
                    checkoutDate: bookingDocData.checkoutdate ? bookingDocData.checkoutdate : null, // Convert checkoutdate
                    custName: bookingDocData.customers && bookingDocData.customers.custname ? bookingDocData.customers.custname : "" // Fetch customer name
                };
            }

            return {
                id: doc1.id,
                data: docData,
                paymode1,
                paymode2,
                createdat: formattedDate,
                bookingData
            };
        });
        const payHistoryData = await Promise.all(payHistoryDataPromises);
        setpayhistory(payHistoryData);

        // 2. Process booking data
        const serviceData = serviucesSnapshot.docs.map((doc) => {
            const data = doc.data();
            const createdAt = data.createdAt;
            const entryTime = createdAt ? createdAt.toDate() : null;
            const entryTimeFomat = moment(entryTime).format('DD-MM-YYYY hh:mm:ss A');

            return {
                id: doc.id,
                data: data,
                entryTime: entryTimeFomat,  // Add the entryTime field
            };
        });
        setserviceData(serviceData);

        // 4. Fetch all payment modes and their totals concurrently
        const paymentModesSnapshot = await getDocs(collection(db, "paymentmodes"));
        const paymentModeIds = paymentModesSnapshot.docs.map((doc) => doc.id);

        // Query payhistory for each payment mode for both paymode1 and paymode2 in parallel
        const totalAmountPromises = paymentModeIds.map(async (paymodeId) => {
            const [paymode1TotalSnapshot, paymode2TotalSnapshot] = await Promise.all([
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("paymode1", "==", paymodeId),
                        where("createdAt", ">=", startOfDay),
                        where("uid", "==", receptId),
                        where("createdAt", "<", endOfDay),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                        where("propertyId", "==", propertyId),
                    )
                ),
                getDocs(
                    query(
                        collection(db, "payhistory"),
                        where("paymode2", "==", paymodeId),
                        where("createdAt", ">=", startOfDay),
                        where("uid", "==", receptId),
                        where("createdAt", "<", endOfDay),
                        where("paymenttype", "==", "B"),
                        where("status", "==", "Working"),
                        where("propertyId", "==", propertyId),
                    )
                )
            ]);

            // Compute the total amount for this payment mode
            const total1 = paymode1TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount1 || 0), 0);
            const total2 = paymode2TotalSnapshot.docs.reduce((sum, doc) => sum + (doc.data().amount2 || 0), 0);

            const paymode = paymentModesSnapshot.docs.find(doc => doc.id === paymodeId)?.data().paymode || "";

            return {
                id: paymodeId,
                paymode,
                totalamount: (total1 + total2).toFixed(2)
            };
        });

        const paymentData = await Promise.all(totalAmountPromises);
        setpaymodes(paymentData);

        const totalAmount = paymentData.reduce((sum, data) => sum + parseFloat(data.totalamount), 0);
        settotal(totalAmount.toFixed(0));

        // ===================================================================================================================================

        // Query payment history
        const q1 = query(
            collection(db, 'payhistory'),
            where('status', '==', 'Working'),
            where('createdAt', '>=', Timestamp.fromDate(startOfDay)),
            where("uid", "==", receptId),
            where('createdAt', '<', Timestamp.fromDate(endOfDay)),
            where("propertyId", "==", propertyId),
        );

        const payhistorySnapshot = await getDocs(q1);
        const paymentHistoryData = await Promise.all(payhistorySnapshot.docs.map(async (doc1) => {
            const data = doc1.data();
            const [paymode1Snap, paymode2Snap] = await Promise.all([
                getDoc(doc(db, "paymentmodes", data.paymode1)),
                getDoc(doc(db, "paymentmodes", data.paymode2))
            ]);
            const paymode1 = paymode1Snap.exists() ? paymode1Snap.data().paymode : "";
            const paymode2 = paymode2Snap.exists() ? paymode2Snap.data().paymode : "";
            const date = data.createdAt.toDate();
            const createdat = moment(date).format('DD-MM-YYYY HH:mm:ss'); // Format date

            return {
                id: doc1.id,
                data,
                paymode1,
                paymode2,
                amount1: data.amount1 || 0, // Amount associated with paymode1
                amount2: data.amount2 || 0, // Amount associated with paymode2
                createdat
            };
        }));


        const checkinDetailsCheckoutQuery = query(
            collection(db, 'checkindetails'),
            where("uid", "==", receptId),
            where('status', '==', 'Checkout'),
            where('checkindate', '==', reportDate),
            where("propertyId", "==", propertyId),

        );

        const checkinDetailsBookedQuery = query(
            collection(db, 'checkindetails'),
            where("uid", "==", receptId),
            where('status', '==', 'Booked'),
            where('checkindate', '==', reportDate),
            where("propertyId", "==", propertyId),

        );

        // Fetch checkin details in parallel
        const [checkinDetailsCheckoutSnapshot, checkinDetailsBookedSnapshot] = await Promise.all([
            getDocs(checkinDetailsBookedQuery),
            getDocs(checkinDetailsCheckoutQuery),
        ]);

        // Combine data from both statuses and ensure uniqueness by bookingid
        const checkinDetailsData = [
            ...checkinDetailsCheckoutSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })),
            ...checkinDetailsBookedSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        ];

        const uniqueCheckinDetails = Array.from(
            new Map(checkinDetailsData.map(item => [item.bookingid, item])).values()
        );

        const bookingIds = uniqueCheckinDetails.map(doc => doc.bookingid);
        if (bookingIds.length === 0) {
            console.log("No bookings found for the specified report date.");
            return;
        }

        // Query bookings table using the bookingIds from checkindetails
        const bookingsQuery = query(
            collection(db, 'reservations'),
            where('__name__', 'in', bookingIds) // Assuming bookingId corresponds to the document ID in bookings
        );

        const bookingsSnapshot = await getDocs(bookingsQuery);
        const bookingsDataMap = bookingsSnapshot.docs.reduce((acc, doc) => {
            acc[doc.id] = { id: doc.id, ...doc.data() }; // Store entire booking data
            return acc;
        }, {});

        // Create a map of payment history by bookingId
        const paymentHistoryMap = paymentHistoryData.reduce((acc, pay) => {
            const bookingId = pay.data.bookingid;

            // Only consider this entry if bookingId exists in bookingsDataMap
            if (bookingsDataMap[bookingId]) {
                if (!acc[bookingId]) {
                    acc[bookingId] = [];
                }
                acc[bookingId].push(pay); // Store payment history related to bookingId
            }
            return acc;
        }, {});

        let allllroomamount = 0;
        let allllfoodamount = 0;
        let alllltotalamount = 0;
        let allllalltoal = 0;
        let allllpaidamount = 0;
        let allllserviceamount = 0;
        let allllpending = 0;
        let noofroomscount = 0;
        let todayspending = 0;
        let pendingReceived = 0;

        const combinedData = await Promise.all(uniqueCheckinDetails.map(async (checkinDetail) => {
            const bookingData = bookingsDataMap[checkinDetail.bookingid] || null;

            // Ensure bookingData exists before accessing its properties
            if (!bookingData) {
                console.warn(`No booking found for booking ID: ${checkinDetail.bookingid}`);
                return null; // Skip this entry if bookingData is null
            }

            const roomamount = bookingData.rooamount || 0;
            const date1 = moment(bookingData.checkindate, 'YYYY-MM-DD');
            const date2 = moment(reportDate, 'YYYY-MM-DD');

            let dayDifference = date2.diff(date1, 'days');
            if (dayDifference === 0) {
                dayDifference = 1;
            }

            const serviceamount = parseFloat(bookingData?.serviceamount) / parseFloat(bookingData.noofdays) || 0;

            const q = query(
                collection(db, 'orders'),
                where('status', '==', 'Bill Pending'),
                where('orderdate', '==', reportDate),
                where('bookingId', '==', checkinDetail.bookingid),
                where("propertyId", "==", propertyId),

            );

            // Fetch documents and calculate the sum of totalamount (for food)
            const querySnapshot = await getDocs(q);
            let foodTotal = 0;
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                foodTotal += data.totalamount || 0; // Ensure 'totalamount' exists
            });

            // Payment history calculation
            let paymentHistory = paymentHistoryMap[checkinDetail.bookingid] || [];
            let paidAmount = paymentHistory.reduce((sum, pay) => sum + pay.amount1 + pay.amount2, 0);

            let totalamount = parseFloat(roomamount) + parseFloat(serviceamount) + parseFloat(foodTotal);
            let alltoal = parseFloat(totalamount) * parseFloat(dayDifference);
            let remaining = parseFloat(alltoal) - parseFloat(paidAmount);

            allllroomamount += parseFloat(roomamount.toFixed(0));
            allllfoodamount += parseFloat(foodTotal.toFixed(0));
            alllltotalamount += parseFloat(totalamount.toFixed(0));
            allllalltoal += parseFloat(alltoal.toFixed(0));
            allllpaidamount += parseFloat(paidAmount.toFixed(0));
            allllserviceamount += parseFloat(serviceamount.toFixed(0));
            allllpending += parseFloat(remaining.toFixed(0));
            noofroomscount += parseFloat(bookingData.rooms.length);

            let pendingReceived1 = 0;
            if (paidAmount > 0) {
                pendingReceived1 = parseFloat(paidAmount) - parseFloat(totalamount);
                pendingReceived += parseFloat(pendingReceived1);
            } else {
                todayspending += parseFloat(totalamount);
            }

            // Return the combined data with food total
            return {
                ...checkinDetail,
                booking: bookingData,
                serviceamount,
                roomamount: roomamount.toFixed(0),
                foodamount: foodTotal.toFixed(0),
                totalamount: totalamount.toFixed(0),
                alltoal: alltoal.toFixed(0),
                paidamount: paidAmount.toFixed(0),
                pending: remaining.toFixed(0),
                todayDays: dayDifference,
                paymentHistory
            };
        }));

        // Remove null values from the final result
        setbookingData(combinedData.filter(item => item !== null));
        console.log(combinedData.filter(item => item !== null));
        setloading(false);
    };

    // Helper function to format date
    const formatDate = (date) => {
        const day = date.getDate().toString().padStart(2, '0');
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const year = date.getFullYear();
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${day}-${month}-${year} ${hours}:${minutes}:${seconds}`;
    };


    const handlePrint = () => {
        window.print();
    };

    const handleFromDate = (e) => {
        setfromDate(e.target.value)
        setloading(false)
    }
    const handleToDate = (e) => {
        settoDate(e.target.value)
        setloading(false)
    }

    return (
        <div>
            <Menu />
            <div className="content-wrapper">
                <section className="content mt-2">
                    <div className="container-fluid">
                        <Typography
                            variant="h6"
                            sx={{
                                backgroundColor: "grey.600",
                                color: "#fff",
                                px: 2,
                                py: 1,
                                borderRadius: 1,
                                display: "inline-block",
                                fontWeight: 600,
                                mb: 2
                            }}
                        >
                            || Receptionist Report ||
                        </Typography>

                        <div className="row">
                            <div className="col-md-12">
                                <Card variant="outlined">
                                    <CardContent>
                                        <Grid className="row" spacing={2} alignItems="center">

                                            {/* Receptionist */}
                                            <Grid className="col-sm-3" md={3}>
                                                <FormControl fullWidth size="small">
                                                    <InputLabel>Select Receptionist</InputLabel>
                                                    <Select
                                                        value={receptId}
                                                        label="Select Receptionist"
                                                        onChange={(e) => setreceptId(e.target.value)}
                                                    >
                                                        <MenuItem value="">
                                                            <em>None</em>
                                                        </MenuItem>
                                                        {recepts.map((item) => (
                                                            <MenuItem key={item.id} value={item.data.uid}>
                                                                {item.data.name}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            {/* From Date */}
                                            <Grid className="col-sm-3" md={3}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="From Date"
                                                    type="date"
                                                    value={fromDate}
                                                    onChange={handleFromDate}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/* To Date */}
                                            <Grid className="col-sm-3" md={3}>
                                                <TextField
                                                    fullWidth
                                                    size="small"
                                                    label="To Date"
                                                    type="date"
                                                    value={toDate}
                                                    onChange={handleToDate}
                                                    InputLabelProps={{ shrink: true }}
                                                />
                                            </Grid>

                                            {/* Button */}
                                            <Grid className="col-sm-3" md={3}>
                                                <Button
                                                    fullWidth
                                                    variant="contained"
                                                    color="info"
                                                    sx={{ height: "40px", fontWeight: 600 }}
                                                    onClick={getReport}
                                                >
                                                    Get Report
                                                </Button>
                                            </Grid>

                                        </Grid>
                                    </CardContent>
                                </Card>

                                <Card className="print-area" >
                                    <CardContent>

                                        {/* HEADER */}
                                        <Grid className="row" spacing={2} alignItems="center" mb={2}>
                                            <Grid className="col-sm-4" md={4} textAlign="center">
                                                <Typography variant="subtitle2">
                                                    From Date : {moment(fromDate).format("DD/MM/YYYY")}
                                                </Typography>
                                            </Grid>

                                            <Grid className="col-sm-4" md={4} textAlign="center">
                                                <Typography variant="h6" fontWeight="bold" textTransform="uppercase">
                                                    {username} Report
                                                </Typography>
                                            </Grid>

                                            <Grid className="col-sm-4" md={4} textAlign="center">
                                                <Typography variant="subtitle2">
                                                    To Date : {moment(toDate).format("DD/MM/YYYY")}
                                                </Typography>
                                            </Grid>
                                        </Grid>

                                        {/* BOOKING REPORT */}
                                        <Typography
                                            variant="subtitle1"
                                            sx={{ bgcolor: "#E0FCFE", p: 1, fontWeight: 600 }}
                                        >
                                            Booking Report
                                        </Typography>

                                        <TableContainer sx={{ mt: 1 }}>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Sr</TableCell>
                                                        <TableCell>Customer</TableCell>
                                                        <TableCell>Check-in</TableCell>
                                                        <TableCell>Check-out</TableCell>
                                                        <TableCell>Days</TableCell>
                                                        <TableCell>Rooms</TableCell>
                                                        <TableCell align="right">Room</TableCell>
                                                        <TableCell align="right">Extra</TableCell>
                                                        <TableCell align="right">Food</TableCell>
                                                        <TableCell align="right">Total</TableCell>
                                                        <TableCell>Payments</TableCell>
                                                        <TableCell>Status</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {bookingData.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{index + 1}</TableCell>
                                                            <TableCell sx={{ textTransform: "capitalize" }}>
                                                                {item.booking.customers.custname}
                                                            </TableCell>
                                                            <TableCell>
                                                                {moment(item.checkindate).format("DD/MM/YYYY")}
                                                            </TableCell>
                                                            <TableCell>
                                                                {moment(item.checkoutdate).format("DD/MM/YYYY")}
                                                            </TableCell>
                                                            <TableCell>{item.todayDays}</TableCell>
                                                            <TableCell>
                                                                {item.booking.rooms.map((r, i) => (
                                                                    <Typography key={i} variant="caption" display="block">
                                                                        {r.roomno} ({r.discount}%)
                                                                    </Typography>
                                                                ))}
                                                            </TableCell>
                                                            <TableCell align="right">{item.roomamount}</TableCell>
                                                            <TableCell align="right">{item.serviceamount}</TableCell>
                                                            <TableCell align="right">{item.foodamount}</TableCell>
                                                            <TableCell align="right">{item.totalamount}</TableCell>

                                                            <TableCell>
                                                                {item.paymentHistory.length > 0 ? (
                                                                    item.paymentHistory.map((p, i) => (
                                                                        <Typography key={i} variant="caption" display="block">
                                                                            {p.paymode1} : {p.data.amount1}
                                                                        </Typography>
                                                                    ))
                                                                ) : (
                                                                    <Typography color="error">Pending</Typography>
                                                                )}
                                                            </TableCell>

                                                            <TableCell>
                                                                {item.booking.checkindate !== moment().format("YYYY-MM-DD") && (
                                                                    <Typography color="success.main">
                                                                        Continued
                                                                    </Typography>
                                                                )}
                                                            </TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        {/* COLLECTION REPORT */}
                                        <Typography
                                            variant="subtitle1"
                                            sx={{ bgcolor: "#E0FCFE", p: 1, mt: 3, fontWeight: 600 }}
                                        >
                                            Collection Report
                                        </Typography>

                                        <TableContainer sx={{ mt: 1 }}>
                                            <Table size="small">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell>Customer</TableCell>
                                                        <TableCell>Room</TableCell>
                                                        <TableCell>Check-in</TableCell>
                                                        <TableCell>Check-out</TableCell>
                                                        <TableCell>Paymode 1</TableCell>
                                                        <TableCell>Amt 1</TableCell>
                                                        <TableCell>Paymode 2</TableCell>
                                                        <TableCell>Amt 2</TableCell>
                                                        <TableCell>Date</TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    {payhistory.map((item, index) => (
                                                        <TableRow key={index}>
                                                            <TableCell>{item.bookingData.custName}</TableCell>
                                                            <TableCell>
                                                                {item.bookingData.rooms.map((r, i) => (
                                                                    <Typography key={i} variant="caption" display="block">
                                                                        {r.roomno}
                                                                    </Typography>
                                                                ))}
                                                            </TableCell>
                                                            <TableCell>{moment(item.bookingData.checkinDate).format("DD-MM-YYYY")}</TableCell>
                                                            <TableCell>{moment(item.bookingData.checkoutDate).format("DD-MM-YYYY")}</TableCell>
                                                            <TableCell>{item.paymode1}</TableCell>
                                                            <TableCell>{item.data.amount1}</TableCell>
                                                            <TableCell>{item.paymode2}</TableCell>
                                                            <TableCell>{item.data.amount2}</TableCell>
                                                            <TableCell>{item.createdat}</TableCell>
                                                        </TableRow>
                                                    ))}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>

                                        {/* PAYMODE SUMMARY */}
                                        <Grid className="row" spacing={1} mt={3}>
                                            {paymodes.map(
                                                (p, i) =>
                                                    p.totalamount > 0 && (
                                                        <Grid className="col-sm-2" key={i}>
                                                            <Paper sx={{ p: 1, textAlign: "center" }}>
                                                                <Typography variant="caption">{p.paymode}</Typography>
                                                                <Typography fontWeight="bold">{p.totalamount}</Typography>
                                                            </Paper>
                                                        </Grid>
                                                    )
                                            )}
                                        </Grid>

                                        {/* TOTAL */}
                                        <Paper sx={{ mt: 3, p: 2, textAlign: "center", bgcolor: "#E0FCFE" }}>
                                            <Typography variant="h6">
                                                Total Collection : ₹ {total} /-
                                            </Typography>
                                        </Paper>

                                    </CardContent>
                                </Card>

                                <center>
                                    <button className='btn btn-success' onClick={handlePrint}>Print Report</button>
                                </center>


                            </div>
                        </div>
                    </div>
                </section >




            </div>



        </div >

    )
}

export default Receptionistreport
